import definition from "../legacy/dhtmlxcommon";
export default function (scheduler) {
  definition();
}